import { Component } from '@angular/core';

@Component({
  selector: 'app-sm-in-nav-footer',
  templateUrl: './sm-in-nav-footer.component.html',
  styleUrls: ['./sm-in-nav-footer.component.css']
})
export class SmInNavFooterComponent {

}
